(function ($) {
    /**
     * Toggle for FAQ, Egna frågor and Tjänster items.
     *
     * Delegated from document so that block previews in the editor, which
     * re-render their markup, keep working without stacking a new handler
     * on every button each time.
     *
     * @date    15/4/19
     * @since   1.0.0
     */
    $(document).on('click', '.expandable-item--title > button', function(e){

      e.preventDefault();

      $(this).parent().parent('.expandable-item').toggleClass('expanded');
      $(this).parent().siblings('.expandable-item--text').slideToggle(200);
      $(this).attr('aria-expanded', function(index,attr){
          return attr == 'false' ? 'true' : 'false';
      });

    });
  })(jQuery);
  